<template>
    <v-row align="center">
        <v-col cols="6" class="font-weight-bold text-capitalize pl-8">
            {{resultadoIndicador.indicador.nombre}}:
        </v-col>
        <v-col cols="6">
            <v-row>
                <v-col v-for="(res, index) in resultadoIndicador.resultadosSolCons" cols="6" class="text-center"
                       :key="index">
                    {{res[tipoResultado]}}<span class="font-italic">{{imprimirNormaUnidad(res.normaUnidad)}}</span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "ResultadoIndicadorComponente",
        props: {
            resultadoIndicador: {type: Object, required: true},
            tipoResultado: {type: String, required: true}
        },
        methods: {
            imprimirNormaUnidad(normaUnidad) {
                if (normaUnidad == "-::-") return "";

                if (normaUnidad.includes("::")) {
                    if (normaUnidad.split("::").length > 1)
                        normaUnidad = normaUnidad.replace("::", " (") + ")";
                    else
                        normaUnidad = normaUnidad.replace("::", "");
                }
                return " " + normaUnidad;
            }
        }
    }
</script>

<style scoped>

</style>